import Image from "next/image";
import {
  DELIVERY_APPROACH_HEADING,
  DELIVERY_APPROACH_STEPS,
} from "@/lib/content/delivery-approach-content";

export default function DeliveryApproachSection() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl">
          <h2 className="mb-16 text-3xl font-medium leading-snug text-text-light dark:text-text-dark sm:text-4xl md:text-5xl md:leading-normal">
            {DELIVERY_APPROACH_HEADING}
          </h2>
          <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
            {DELIVERY_APPROACH_STEPS.map((step) => (
              <div key={step.number}>
                <div className="mb-4 flex items-baseline gap-3">
                  <span className="text-xl font-medium text-text-muted-light dark:text-text-muted-dark">
                    {step.number}
                  </span>
                  <h3 className="text-xl font-medium text-text-light dark:text-text-dark">
                    {step.title}
                  </h3>
                  <Image
                    src={step.shape}
                    alt=""
                    width={24}
                    height={24}
                    className="ml-auto flex-shrink-0"
                  />
                </div>
                <p className="pl-8 text-lg font-light leading-relaxed text-text-muted-light dark:text-text-muted-dark">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
